import { render, staticRenderFns } from "./RelatedCase.vue?vue&type=template&id=d65cf108&"
import script from "./RelatedCase.vue?vue&type=script&lang=js&"
export * from "./RelatedCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports